// extracted by mini-css-extract-plugin
export default {"rootStyles":"style_rootStyles__slLyK","root":"style_root__Fob6I"};